/*  MUI  */
import { Box } from '@auviknetworks/iceberg-ui';

/* Shared */
import { Form, FormTextInput } from 'application/Shared/Components/Form';
import { Notify } from 'application/Shared/Helpers';
import { Modal, ModalBody, ModalFormFooter } from 'application/Shared/Modals';
import { debug } from 'application/Shared/Utils';

/* Hooks */
import { usePutUser } from 'hooks/dataAccess/User/user';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

// Should probably use some sort of validator library. See react-hook-form docs for suggestions.
// https://react-hook-form.com/api/useform/#resolver
const validate = async ({ t, values }) => {
    const results = { errors: {}, values: {} };

    if (!values.firstName.trim()) {
        results.errors.firstName = {
            message: t('Edit.user_details.error.first_name'),
            type: 'required'
        };
    }

    if (!values.lastName.trim()) {
        results.errors.lastName = {
            message: t('Edit.user_details.error.last_name'),
            type: 'required'
        };
    }

    if (!Object.keys(results.errors).length) {
        results.values = values;
    }

    return results;
};

const save = async ({
    clientId,
    onModalClose,
    putUser,
    t,
    user,
    userId,
    values
}) => {
    const { firstName, lastName, title } = values;

    const trimmedfirstName = firstName.trim();
    const trimmedLastName = lastName.trim();
    const trimmedTitle = title.trim();

    const payload = {
        anonymous: false,
        firstName: trimmedfirstName,
        lastName: trimmedLastName,
        platformTenantId: clientId,
        title: trimmedTitle
    };

    if (
        trimmedfirstName === user?.firstName &&
        trimmedLastName === user?.lastName &&
        trimmedTitle === user?.title
    ) {
        onModalClose();
        return;
    }

    try {
        const response = await putUser({ id: userId, params: payload });
        if (response) {
            Notify.s(t('Edit.user_details.success.saving'));
            onModalClose(true);
        } else {
            Notify.e(t('Edit.user_details.error.saving'));
            onModalClose();
        }
    } catch (err) {
        debug.e('EditUser save failed', err);
        Notify.e(t('Edit.user_details.error.saving'));
        onModalClose();
    }
};

export const EditUser = ({ onModalClose, open, user }) => {
    const { t } = useTranslation();
    const { clientId, userId } = useParams();

    const { putUser } = usePutUser();

    return (
        <Modal
            open={open}
            title={t('Edit.user_details')}
            onClose={onModalClose}
            paperProps={{ minWidth: '600px' }}
            data-testid="userHeaderEditNameModal"
        >
            <ModalBody style={{ padding: 0 }}>
                <Box>
                    <Form
                        defaultValues={{
                            firstName: user?.firstName,
                            lastName: user?.lastName,
                            title: user?.title
                        }}
                        validator={(values) => validate({ t, values })}
                        onSubmit={(values) =>
                            save({
                                clientId,
                                onModalClose,
                                putUser,
                                t,
                                user,
                                userId,
                                values
                            })
                        }
                    >
                        <Box m={4}>
                            <FormTextInput
                                name="firstName"
                                label={t('Common.first_name')}
                                placeholder={t('Common.first_name')}
                                required
                            />
                            <FormTextInput
                                name="lastName"
                                label={t('Common.last_name')}
                                placeholder={t('Common.last_name')}
                                required
                            />
                            <FormTextInput
                                name="title"
                                label={t('Common.title')}
                                placeholder={t('Common.title')}
                            />
                        </Box>

                        <ModalFormFooter onClose={onModalClose} />
                    </Form>
                </Box>
            </ModalBody>
        </Modal>
    );
};
